import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledRadioGroupRootProps } from './RadioGroup.types';

export const StyledRadioGroup = styled('fieldset')<StyledRadioGroupRootProps>(
  () => {
    return {};
  },
  ...getAllStyledProps,
);
